export enum NV200Statuses {
  _1 = 'DISPENSING',
  _2 = 'DISPENSED',
  _5 = 'JAMMED',
  _7 = 'FLOATING',
  _8 = 'FLOATED',
  _9 = 'TIMEOUT',
  _10 = 'INCOMPLETE_PAYOUT',
  _11 = 'INCOMPLETE_FLOAT',
  _12 = 'CASHBOX_PAID',
  _13 = 'COIN_CREDIT',
  _14 = 'EMPTYING',
  _15 = 'EMPTIED',
  _16 = 'FRAUD_ATTEMPT',
  _17 = 'DISABLED',
  _18 = 'NOTE_STORED',
  _20 = 'NOTE_READ',
  _21 = 'NOTE_CREDIT',
  _23 = 'NOTE_REJECTED',
  _24 = 'NOTE_STACKING',
  _25 = 'NOTE_STACKED',
  _31 = 'CASHBOX_REMOVED',
  _32 = 'CASHBOX_REPLACED',
  _48 = 'ERROR_DURING_PAYOUT',
  _99 = 'NOT_CONNECTED',
}
